/**
 * The pictures a "What's new" line can carry — icons, one color each, so a
 * line reads at a glance. Keys mirror WHATS_NEW_PICS on the server.
 */
import {
    AlertTriangle,
    CalendarDays,
    Camera,
    CheckCircle2,
    ClipboardList,
    Clock,
    DollarSign,
    Lock,
    MapPin,
    Phone,
    Star,
    Truck,
    User,
    Wrench,
    type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";
import type { WhatsNewPic } from "@/lib/whats-new";

export const PIC: Record<WhatsNewPic, { icon: LucideIcon; tone: string; label: string }> = {
    truck: { icon: Truck, tone: "text-amber-700 dark:text-amber-300", label: "Truck" },
    check: { icon: CheckCircle2, tone: "text-emerald-700 dark:text-emerald-300", label: "Check" },
    lock: { icon: Lock, tone: "text-amber-700 dark:text-amber-300", label: "Lock" },
    phone: { icon: Phone, tone: "text-emerald-700 dark:text-emerald-300", label: "Phone" },
    calendar: { icon: CalendarDays, tone: "text-blue-700 dark:text-blue-300", label: "Calendar" },
    camera: { icon: Camera, tone: "text-blue-700 dark:text-blue-300", label: "Camera" },
    wrench: { icon: Wrench, tone: "text-slate-700 dark:text-slate-300", label: "Wrench" },
    clipboard: { icon: ClipboardList, tone: "text-blue-700 dark:text-blue-300", label: "Clipboard" },
    alert: { icon: AlertTriangle, tone: "text-red-700 dark:text-red-300", label: "Warning" },
    star: { icon: Star, tone: "text-amber-700 dark:text-amber-300", label: "Star" },
    map: { icon: MapPin, tone: "text-red-700 dark:text-red-300", label: "Map pin" },
    clock: { icon: Clock, tone: "text-blue-700 dark:text-blue-300", label: "Clock" },
    money: { icon: DollarSign, tone: "text-emerald-700 dark:text-emerald-300", label: "Money" },
    person: { icon: User, tone: "text-blue-700 dark:text-blue-300", label: "Person" },
};

export function NotePic({ pic, className }: { pic: WhatsNewPic; className?: string }) {
    const p = PIC[pic] ?? PIC.check;
    const Icon = p.icon;
    return (
        <span
            className={cn("grid place-items-center rounded-xl bg-blue-50 dark:bg-blue-950/50", className)}
            aria-hidden
        >
            <Icon className={cn("h-1/2 w-1/2", p.tone)} />
        </span>
    );
}
